{
  "CreateYourProject": "Crea tu proyecto",
  "BeginYourJourney": "Comienza tu viaje",
  "ProjectName": "Nombre del proyecto",
  "ProjectOrCompanyName": "Nombre del proyecto o empresa",
  "ProjectBased": "¿Dónde esta establecido tu proyecto?",
  "SearchForCity": "Busca tu ciudad aquí",
  "ProjectStage": "Etapa del proyecto",
  "Seed": "Semilla",
  "SeedContinued": "Solo un indicio de una idea",
  "Planning": "Planificación",
  "PlanningContinued": "Prototipos y conceptos de prueba",
  "Startup": "Puesta en marcha",
  "Launched": "Lanzada",
  "Growth": "En Crecimiento",
  "GrowthContinued": "Financiado y expandiéndose",
  "Mature": "Maduro",
  "MatureContinued": "Establecido y estable",
  "Industry": "Industria",
  "SelectIndustry": "Seleccionar industria",
  "creating": "Creando...",
  "create": "Crear",
  "PleaseLogin": "Por favor, Inicia sesión",
  "InviteTeammatesHere": "Invita a tus compañeros de equipo a tu proyecto aquí:",
  "*required": "*requerido",
  "InviteTeammates": "Invitar compañeros de equipo",
  "CreateProject": "Crea un Proyecto",
  "Select Industry": "Seleccionar industria"
}
